module.exports = __webpack_public_path__ + "img/check.109ab399.svg";